import React, { useState, useEffect, useRef } from 'react'
import qr_img from '../../assets/img/vending/qr.png'
import VendingModalKeyCode from './VendingModalKeyCode'
import ErrorAlert from '../../components/Alerts/ErrorAlert';
import SuccessAlert from '../../components/Alerts/SuccessAlert';
import LoadingAlert from '../../components/Alerts/LoadingAlert';

//IMG
import scanQR2 from './img/scanyourqr.gif'
import Logo from '../../assets/img/logos/logo.png'
import scanQR3 from './img/icons/escaneo-qr.png'
import keyboard from './img/icons/teclado.png'

//api
import { AuthFetchAPI } from '../../api/Auth';
import { DivicesFechtAPI } from '../../api/Divices';
//css
import "./css/vending.login.css"
import "./login.css"


function VendingModalQr({ setEventHandler, showModalKeyCode, setShowModalKeyCode }) {
   const [codeString, setCodeString] = useState("")
   const [codeSesion, setCodeSesion] = useState({
      business_code: "0000",
      branchoffice_code: "0000",
      machine_code: "0000",
   });

   const inputRefLog = useRef(null);
   setTimeout(() => {
      inputRefLog.current.focus()
   }, 3000);

   //reload the page
   const reload = () => {
      window.location.reload()
   }

   //get divices of the machine
   const getdivise = async (token, data) => {
      try {
         const response = await DivicesFechtAPI.getDivices(data.id, token)
         let dataMachine = response.data.data

         localStorage.setItem('machine_vending', JSON.stringify({ ...data, divices: dataMachine }));
         localStorage.setItem('positions', "[]");
         setShowModalKeyCode(false)
         //interval of reload the page
         setInterval(reload, 2000)
      } catch (err) {
         console.log(err);
      }
   }

   const authMachineVending = async () => {
      try {
         const response = await AuthFetchAPI.authMachine(codeSesion.business_code, codeSesion.branchoffice_code, codeSesion.machine_code);
         console.log(response);
         SuccessAlert()

         //save data auth in localStorage
         localStorage.setItem('x-access-token', response.data.token);
         localStorage.setItem('business_vending', JSON.stringify(response.data.business));
         localStorage.setItem('branchoffice_vending', JSON.stringify(response.data.branchoffice));
         getdivise(response.data.token, response.data.machine)

      } catch (err) {

         setCodeSesion({
            business_code: "0000",
            branchoffice_code: "0000",
            machine_code: "0000",
         });

         ErrorAlert('', err.response.data.error, 'error')
         document.getElementById("inputCodeQr").value = ""
         // message, title, icon
         console.log(err);
      }
   }

   const handleChange = (e) => {

      if (e.key === 'Enter') {
         LoadingAlert()
         let inputValue = e.target.value
         console.log(inputValue);

         let arrayCodeString = inputValue.split("X");
         console.log(arrayCodeString);

         codeSesion.business_code = arrayCodeString[3]
         codeSesion.branchoffice_code = arrayCodeString[2]
         codeSesion.machine_code = arrayCodeString[1]
         setCodeSesion(codeSesion)
         authMachineVending()

      }
   }
   return (
      <>

         {/* ==========================================================
    Pantalla de Login (Validación de kiosko)
    Lógica preservada: inputRefLog, Logo, scanQR3, keyboard,
    setShowModalKeyCode, handleChange, VendingModalKeyCode + props
    ========================================================== */}
         <>
            <main
               className="vmlg-root"
               onClick={() => (inputRefLog.current.focus())}
            >

               {/* Halo azul de fondo */}
               <div className="vmlg-halo" />

               {/* ========== HEADER ========== */}
               <header className="vmlg-header">
                  <div className="vmlg-logo-frame">
                     <img className="vmlg-logo" src={Logo} alt="Smart Pay" />
                  </div>

                  <div className="vmlg-header-titles">
                     <span className="vmlg-eyebrow">Bienvenido</span>
                     <h1 className="vmlg-title">
                        Inicio de <em>sesión</em>
                     </h1>
                     <p className="vmlg-subtitle">Elige una opción para validarte</p>
                  </div>
               </header>

               {/* ========== CENTRO: dos opciones ========== */}
               <main className="vmlg-main">

                  {/* Opción 1: QR */}
                  <section className="vmlg-option vmlg-option-qr">
                     <div className="vmlg-option-step">Opción 1</div>

                     <div className="vmlg-option-icon">
                        <i className="uil uil-qrcode-scan"></i>
                     </div>

                     <h2 className="vmlg-option-title">Escáner QR</h2>

                     {/* <div className="vmlg-option-media">
                        <img
                           src={scanQR3}
                           alt="Escanear QR"
                           className="vmlg-option-img"
                           loading="lazy"
                        />
                     </div> */}

                     <p className="vmlg-option-desc">
                        Coloca el código QR en el escáner de la máquina
                     </p>

                     <div className="vmlg-option-hint">
                        <span className="vmlg-option-hint-dot" />
                        <span>Esperando escaneo</span>
                     </div>
                  </section>

                  {/* Separador "O" */}
                  <div className="vmlg-divider">
                     <span className="vmlg-divider-line" />
                     <span className="vmlg-divider-text">o</span>
                     <span className="vmlg-divider-line" />
                  </div>

                  {/* Opción 2: Códigos manuales */}
                  <section className="vmlg-option vmlg-option-manual">
                     <div className="vmlg-option-step">Opción 2</div>

                     <div className="vmlg-option-icon vmlg-option-icon-green">
                        <i className="uil uil-keyboard"></i>
                     </div>

                     <h2 className="vmlg-option-title">Códigos de validación</h2>
{/* 
                     <div className="vmlg-option-media">
                        <img
                           src={keyboard}
                           alt="Teclado"
                           className="vmlg-option-img"
                           loading="lazy"
                        />
                     </div> */}

                     <button
                        type="button"
                        className="vmlg-option-btn"
                        onClick={() => (setShowModalKeyCode(true))}
                     >
                        <i className="uil uil-keyboard-show"></i>
                        <span>Ingresar código</span>
                     </button>

                     <p className="vmlg-option-desc">
                        Presiona <b>Ingresar código</b> e introduce los códigos en la máquina
                     </p>
                  </section>

               </main>

               {/* ========== FOOTER ========== */}
               <footer className="vmlg-footer">
                  <span className="vmlg-footer-small">Powered by</span>
                  <h3 className="vmlg-footer-brand">Smart Retail Group</h3>
               </footer>

               {/* Input oculto del escáner — preservado */}
               <input
                  id="inputCodeQr"
                  className="vmlg-hidden-input"
                  ref={inputRefLog}
                  inputMode="none"
                  type="text"
                  onKeyPress={(e) => handleChange(e)}
                  autoFocus
               />
            </main>

            {/* Modal de códigos — preservado tal cual */}
            <VendingModalKeyCode
               codeSesion={codeSesion}
               setCodeSesion={setCodeSesion}
               authMachineVending={authMachineVending}
               showModalKeyCode={showModalKeyCode}
               setShowModalKeyCode={setShowModalKeyCode}
            />
         </>
      </>
   )
}

export default VendingModalQr